// Generated by `bazel run i18n`. Do not edit by hand.
import bulkFulfillments_aa5150c2 from "./en/src--bulk-fulfillments.json";
import allShoppedServices_c0b8ef4c from "./en/src--common--all-shopped-services.json";
import cancelOrderItems_6ccbc3a0 from "./en/src--common--cancel-order-items.json";
import printBarcode_3eab26a6 from "./en/src--common--print-barcode.json";
import carrierClaimInfo_c56700b7 from "./en/src--common--shipping-claim--carrier-claim-info.json";
import shippingClaim_3c9ca73f from "./en/src--common--shipping-claim.json";
import simpleRateTooltip_bd02be7d from "./en/src--common--simple-rate-tooltip.json";
import common_7fe6b6cc from "./en/src--common.json";
import columns_f23fddc1 from "./en/src--fulfillment-groups--columns.json";
import fulfillmentGroupSlideout_5323dcb6 from "./en/src--fulfillment-groups--fulfillment-group-slideout.json";
import fulfillmentGroups_0688c318 from "./en/src--fulfillment-groups.json";
import mobileLauncher_afcf5141 from "./en/src--mobile-launcher.json";
import filters_3ec1d939 from "./en/src--order-edits--filters.json";
import orderEdits_fa87c4e1 from "./en/src--order-edits.json";
import rateCalculator_b54e576a from "./en/src--rate-calculator.json";
import modals_5d52ef5b from "./en/src--scan--modals.json";
import packingStation_e2223314 from "./en/src--scan--packing-station.json";
import scan_43ddf832 from "./en/src--scan.json";
import aboutOms_aa7fdd58 from "./en/src--setting--about-oms.json";
import automations_9ff329ce from "./en/src--setting--automations.json";
import carrierAccounts_27b70df0 from "./en/src--setting--carrier-accounts.json";
import components_fd0736ca from "./en/src--setting--components.json";
import customs_521074f0 from "./en/src--setting--customs.json";
import integrationUtils_224e3076 from "./en/src--setting--integration-utils.json";
import locations_e8726e28 from "./en/src--setting--locations.json";
import editor_739de629 from "./en/src--setting--markets--editor.json";
import markets_6eabe9cf from "./en/src--setting--markets.json";
import oms_01502cf9 from "./en/src--setting--oms.json";
import photoInstructions_45239edd from "./en/src--setting--photo-instructions.json";
import presets_a9110ef0 from "./en/src--setting--presets.json";
import printing_75091b97 from "./en/src--setting--printing.json";
import reports_09b2628f from "./en/src--setting--reports.json";
import restrictions_d4ef3a7d from "./en/src--setting--restrictions.json";
import returnAddresses_7e181701 from "./en/src--setting--return-addresses.json";
import routingRules_b0d0d033 from "./en/src--setting--routing-rules.json";
import totes_6299b507 from "./en/src--setting--totes.json";
import workOrderFlows_ec8a5254 from "./en/src--setting--work-order-flows.json";
import setting_da37fa54 from "./en/src--setting.json";
import shippingClaims_59eead78 from "./en/src--shipping-claims.json";
import shippingLabels_7924dc7a from "./en/src--shipping-labels.json";
import binAssignment_92aefd15 from "./en/src--wms--bin-assignment.json";
import binCount_4b6afa7c from "./en/src--wms--bin-count.json";
import consolidation_a21c6e56 from "./en/src--wms--consolidation.json";
import dashboard_8165b3fe from "./en/src--wms--dashboard.json";
import dashboards_fdb4a700 from "./en/src--wms--dashboards.json";
import flush_f4963977 from "./en/src--wms--flush.json";
import instantTransfer_437df9d1 from "./en/src--wms--instant-transfer.json";
import inventoryLevelLedger_e5484429 from "./en/src--wms--inventory-level-ledger.json";
import itemPhotoRequest_283e2c90 from "./en/src--wms--item-photo-request.json";
import itemWorkRequests_40e03df3 from "./en/src--wms--item-work-requests.json";
import createPickSessionModals_5179bffb from "./en/src--wms--pick-sessions--create-pick-session-modals.json";
import routeViewer_ab88ab8a from "./en/src--wms--pick-sessions--route-viewer.json";
import pickSessions_cf96f189 from "./en/src--wms--pick-sessions.json";
import receiveToBin_af8181d3 from "./en/src--wms--receive-to-bin.json";
import receiving_440c757b from "./en/src--wms--receiving.json";
import replenishmentReport_5c715e33 from "./en/src--wms--replenishment-report.json";
import replenishment_4c3ee202 from "./en/src--wms--replenishment.json";
import shared_d970164a from "./en/src--wms--shared.json";
import skuLookup_8195454d from "./en/src--wms--sku-lookup.json";
import storageLocations_235f6374 from "./en/src--wms--storage-locations.json";
import transfer_1de16c70 from "./en/src--wms--transfer.json";
import nodes_3f6bd0db from "./en/src--wms--warehouse-builder--nodes.json";
import workOrderStation_8e378f55 from "./en/src--wms--work-order-station.json";
import src_c1a2d0b5 from "./en/src.json";

export default Object.assign(
  {},
  bulkFulfillments_aa5150c2,
  allShoppedServices_c0b8ef4c,
  cancelOrderItems_6ccbc3a0,
  printBarcode_3eab26a6,
  carrierClaimInfo_c56700b7,
  shippingClaim_3c9ca73f,
  simpleRateTooltip_bd02be7d,
  common_7fe6b6cc,
  columns_f23fddc1,
  fulfillmentGroupSlideout_5323dcb6,
  fulfillmentGroups_0688c318,
  mobileLauncher_afcf5141,
  filters_3ec1d939,
  orderEdits_fa87c4e1,
  rateCalculator_b54e576a,
  modals_5d52ef5b,
  packingStation_e2223314,
  scan_43ddf832,
  aboutOms_aa7fdd58,
  automations_9ff329ce,
  carrierAccounts_27b70df0,
  components_fd0736ca,
  customs_521074f0,
  integrationUtils_224e3076,
  locations_e8726e28,
  editor_739de629,
  markets_6eabe9cf,
  oms_01502cf9,
  photoInstructions_45239edd,
  presets_a9110ef0,
  printing_75091b97,
  reports_09b2628f,
  restrictions_d4ef3a7d,
  returnAddresses_7e181701,
  routingRules_b0d0d033,
  totes_6299b507,
  workOrderFlows_ec8a5254,
  setting_da37fa54,
  shippingClaims_59eead78,
  shippingLabels_7924dc7a,
  binAssignment_92aefd15,
  binCount_4b6afa7c,
  consolidation_a21c6e56,
  dashboard_8165b3fe,
  dashboards_fdb4a700,
  flush_f4963977,
  instantTransfer_437df9d1,
  inventoryLevelLedger_e5484429,
  itemPhotoRequest_283e2c90,
  itemWorkRequests_40e03df3,
  createPickSessionModals_5179bffb,
  routeViewer_ab88ab8a,
  pickSessions_cf96f189,
  receiveToBin_af8181d3,
  receiving_440c757b,
  replenishmentReport_5c715e33,
  replenishment_4c3ee202,
  shared_d970164a,
  skuLookup_8195454d,
  storageLocations_235f6374,
  transfer_1de16c70,
  nodes_3f6bd0db,
  workOrderStation_8e378f55,
  src_c1a2d0b5,
);
